module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerBoldItalic.46544c52.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerBoldItalic.otf
// module id = 1061
// module chunks = 0